import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    isOpen: boolean = false
    jsonData: any
    jsonDataOrig: any

    @Input('isMobile') isMobile;
    @Input('isHome') isHome;

    constructor(
        private breakpointObserver: BreakpointObserver,
    ) {
        this.jsonDataOrig = {
            liveTv: [
                {
                    id: 'MovieSphere',
                    logo: 'assets/img/home/moviesphere-large-logo.png',
                    url: '/movie-sphere',
                },
                {
                    id: '50centaction',
                    logo: 'assets/img/home/50centaction/50centaction-logo-mobile.png',
                    url: '/50centaction',
                },
                {
                    id: 'hersphere',
                    logo: 'assets/img/home/hersphere-large-logo.png',
                    url: '/her-sphere',
                },
                {
                    id: 'ebonytv',
                    logo: 'assets/img/home/ebonytv-large-logo-v2.png',
                    url: '/ebonytv',
                },
                {
                    id: 'outersphere',
                    logo: 'assets/img/home/outersphere-large-logo.png',
                    url: '/outer-sphere',
                },
                {
                    id: 'lawless',
                    logo: 'assets/img/home/lawless-large-logo-temp-v2.png',
                    url: '/lawless',
                },
                {
                    id: 'extreme-jobs',
                    logo: 'assets/img/home/Extreme-Jobs-title-v2.png',
                    url: '/extreme-jobs',
                },
                {
                    id: 'moviesphere-gold',
                    logo: 'assets/img/home/moviesphere-gold-large-logo.png',
                    url: 'https://MovieSphereGold.com',
                    external: true
                },

            ],
            series: [
                {
                    title: 'Designated Survivor',
                    logo: 'assets/img/channel/designated-survivor/designated-survivor-small-rectangle.jpg',
                    url: '/channel/designated-survivor',
                    order: 1,
                    orderMob: 1,
                },
                {
                    title: 'The Conners',
                    logo: 'assets/img/channel/new2/the-conners-small-rectangle.jpg',
                    url: '/channel/the-conners',
                    order: 8,
                    orderMob: 8,
                },
                {
                    title: 'Nash Bridges',
                    logo: 'assets/img/channel/new2/nash-bridges-small-rectangle.jpg',
                    url: '/channel/nash-bridges',
                    order: 4,
                    orderMob: 2,
                },
                // {
                //     title: 'Grace and Frankie',
                //     logo: 'assets/img/channel/new2/grace-and-frankie-small-rectangle.jpg',
                //     url: '/channel/grace-and-frankie',
                //     order: 99,
                //     orderMob: 9,
                // },
                {
                    title: 'Are We There Yet?',
                    logo: 'assets/img/menu/are-we-there-yet-small-rectangle.jpg',
                    url: '/channel/are-we-there-yet',
                    order: 7,
                    orderMob: 4,
                },
                {
                    title: 'Anger Management',
                    logo: 'assets/img/menu/anger-management-small-rectangle.jpg',
                    url: '/channel/anger-management',
                    order: 3,
                    orderMob: 10,
                },
                {
                    title: 'Ghost Hunters',
                    logo: 'assets/img/menu/ghost-hunters-small-rectangle.jpg',
                    url: '/channel/ghost-hunters',
                    order: 10,
                    orderMob: 5,
                },
                {
                    title: 'Wanted Dead Or Alive',
                    logo: 'assets/img/menu/wanted-dead-or-alive-small-rectangle.jpg',
                    url: '/channel/wanted-dead-or-alive',
                    order: 6,
                    orderMob: 11,
                },
                {
                    title: 'Celebrity Name Game',
                    logo: 'assets/img/menu/celebrity-wedding-small-rectangle.jpg',
                    url: '/channel/celebrity-name-game',
                    order: 2,
                    orderMob: 6,
                },

                {
                    title: 'Caught In Providence',
                    logo: 'assets/img/menu/caught-in-providence-small-rectangle.jpg',
                    url: '/channel/caught-in-providence',
                    order: 9,
                    orderMob: 12,
                },


                {
                    title: 'Nashville',
                    logo: 'assets/img/menu/nashville-small-rectangle.jpg',
                    url: '/channel/nashville',
                    order: 5,
                    orderMob: 7,
                },

                {
                    title: 'Love Thy Neighbor',
                    logo: 'assets/img/menu/love-thy-neighbor-small-rectangle.jpg',
                    url: '/channel/love-thy-neighbor',
                    order: 13,
                    orderMob: 13,
                },
                {
                    title: 'Wendy Williams Show',
                    logo: 'assets/img/menu/wendy-williams-small-rectangle.jpg',
                    url: '/channel/wendy-williams',
                    order: 14,
                    orderMob: 14,
                },
                {
                    title: 'Weeds and Nurse Jackie',
                    logo: 'assets/img/menu/weeds-nurse-jackie-small-rectangle.jpg',
                    url: '/channel/weeds-and-nurse-jackie',
                    order: 15,
                    orderMob: 15,
                },
                {
                    title: 'Heartland',
                    logo: 'assets/img/channel/heartland/heartland-small-rectangle.jpg',
                    url: '/channel/heartland',
                    order: 16,
                    orderMob: 16,
                },
                {
                    title: 'Wicked Tuna',
                    logo: 'assets/img/menu/wicked-tuna-small-rectangle.jpg',
                    url: '/channel/wicked-tuna',
                    order: 17,
                    orderMob: 17,
                },









            ]
        }

        breakpointObserver.observe([
            Breakpoints.HandsetLandscape,
            Breakpoints.HandsetPortrait
        ]).subscribe(result => {
            if (result.matches) {
                this.isMobile = true;

                this.jsonData = this.jsonDataOrig           
                this.jsonData.series = this.jsonData.series.sort( (a, b) => a.orderMob - b.orderMob)     
            }
            else {
                this.isMobile = false;
                this.jsonData = this.jsonDataOrig
                this.jsonData.series = this.jsonData.series.sort( (a, b) => {
                    if(!a.order ) return 0
                    if(!b.order) return 0
                    return a.order - b.order 
                })
            }
        });
    }

    ngOnInit(): void {

    }

    onToggleDropdown() {
        if (this.isOpen) {
            this.onClose()
        }
        else {
            this.onOpen()
        }
    }

    onOpen() {
        this.isOpen = true
        console.log('Header opening')


    }

    onClose() {
        this.isOpen = false
        console.log('Header closing')
    }
}
